/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { I18n as I } from 'react-redux-i18n';

import LookupsHelper from 'lib/LookupsHelper';
import { formatCurrency, isArray, isFunc, isNil, PartTypes } from 'vdlib';
import Store from 'data/Store';

let partTypes = null,
  partTypesConfig = {};

const loadPartTypes = () => {
  let lookups = Store.getState().app.lookups;
  partTypes =
    !isNil(lookups) && isArray(lookups.partTypes) ? lookups.partTypes : null;
  partTypesConfig = {
    [LookupsHelper.getIdByDescription(partTypes, PartTypes.New)]: {
      labelClassName: 'success',
      title: I.t('PART_TYPE_NEW'),
      short: I.t('PART_TYPE_NEW_SHORT'),
    },
    [LookupsHelper.getIdByDescription(partTypes, PartTypes.Used)]: {
      labelClassName: 'danger',
      title: I.t('PART_TYPE_USED'),
      short: I.t('PART_TYPE_USED_SHORT'),
    },
    [LookupsHelper.getIdByDescription(partTypes, PartTypes.Imitation)]: {
      labelClassName: 'warning',
      title: I.t('PART_TYPE_IMITATION'),
      short: I.t('PART_TYPE_IMITATION_SHORT'),
    },
  };
};

const tooltipSpanStyle = { padding: '0' };
const renderLabel = (record, bid, isLast, onClick) => {
  let config = partTypesConfig[bid.PartTypeID],
    className = `part-type-label label label-${config.labelClassName} ${
      isLast ? '' : 'mr-sm'
    }`;
  return isFunc(onClick) ? (
    <a
      href="#"
      key={`bid-${bid.PartTypeID}`}
      className={`${className} bid-type-clickable pointer`}
      onClick={e => {
        if (e && e.preventDefault) e.preventDefault();
        onClick(record, bid);
        return false;
      }}
    >
      {config.short}
    </a>
  ) : (
    <div key={`bid-${bid.PartTypeID}`} className={className}>
      {config.short}
    </div>
  );
};
const renderTooltip = bid => {
  let config = partTypesConfig[bid.PartTypeID];
  return (
    <div
      className="clearfix text-left bid-tooltip-item"
      key={`${config.title}-tooltip`}
    >
      <span className="float-right">{formatCurrency(bid.Amount)}</span>
      <span
        style={tooltipSpanStyle}
        className={`label label-${config.labelClassName} pr mr-sm`}
      />
      <span className="bold mr-sm">{config.title}:</span>
    </div>
  );
};

const bidSorter = (a, b) => (a.Amount < b.Amount ? -1 : 1);

export const getBidsTooltipCellRenderer = (visiblePartTypes, onClick) => {
  return (value, record) => {
    if (isNil(value)) return <span />;

    if (!Array.isArray(visiblePartTypes) || visiblePartTypes.length === 0)
      return false;

    if (!isArray(partTypes)) loadPartTypes();

    const tooltips = [];
    const labels = [];
    const eligibleBids = visiblePartTypes
      .map(partType => LookupsHelper.getIdByDescription(partTypes, partType))
      .sort()
      .map(
        partTypeId =>
          value.filter(b => b.PartTypeID === partTypeId).sort(bidSorter)[0]
      )
      .filter(bid => !isNil(bid));

    eligibleBids.forEach((bid, idx, arr) => {
      tooltips.push(renderTooltip(bid));
      labels.push(renderLabel(record, bid, idx === arr.length - 1, onClick));
    });

    return labels.length === 0 ? (
      'Καμία Προσφορά'
    ) : (
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id={`bid-tooltip-${value}`}>{tooltips}</Tooltip>}
      >
        <div>{labels}</div>
      </OverlayTrigger>
    );
  };
};
